module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<div>\n<!-- PLUPLOADER -->\n<button class=\"upload untaggedUpload\" id=\"upload_<%- config.mode %>\"><i class=\"fi fi-upload\" aria-hidden=\"true\"></i>&nbsp;&nbsp;<%= storage.__('button:upload.' + config.mode) %></button>\n<%\nif(config.showTaggedUpload){\n%><button class=\"upload taggedUpload\"><i class=\"fi fi-upload-tagged\" aria-hidden=\"true\"></i>&nbsp;&nbsp;<%= storage.__('button:upload.tagged.' + config.mode) %></button><%\n}\n%>\n<div class=\"progress\">\n<div class=\"background\"></div>\n<div class=\"content\">...</div>\n</div>\n<div class=\"uploads\">\n</div>\n<% if(config.showResultsContainer){ %>\n<div class=\"results\"></div>\n<% } %>\n</div>"
  , __filename = "..\\..\\npm\\frontend-controller\\baseComponents\\form\\media\\upload\\plupload\\plupload.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div>\n<!-- PLUPLOADER -->\n<button class=\"upload untaggedUpload\" id=\"upload_")
    ; __line = 3
    ; __append( config.mode )
    ; __append("\"><i class=\"fi fi-upload\" aria-hidden=\"true\"></i>&nbsp;&nbsp;")
    ; __append(escapeFn( storage.__('button:upload.' + config.mode) ))
    ; __append("</button>\n")
    ; __line = 4
    ; 
if(config.showTaggedUpload){

    ; __line = 6
    ; __append("<button class=\"upload taggedUpload\"><i class=\"fi fi-upload-tagged\" aria-hidden=\"true\"></i>&nbsp;&nbsp;")
    ; __append(escapeFn( storage.__('button:upload.tagged.' + config.mode) ))
    ; __append("</button>")
    ; 
}

    ; __line = 8
    ; __append("\n<div class=\"progress\">\n<div class=\"background\"></div>\n<div class=\"content\">...</div>\n</div>\n<div class=\"uploads\">\n</div>\n")
    ; __line = 15
    ;  if(config.showResultsContainer){ 
    ; __append("\n<div class=\"results\"></div>\n")
    ; __line = 17
    ;  } 
    ; __append("\n</div>")
    ; __line = 18
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=..\..\npm\frontend-controller\baseComponents\form\media\upload\plupload\plupload.ejs

}